<template>
  <section>
    <v-row class="mb-4" no-gutters>
      <v-col>
        <p class="sms-recover-number">{{ hiddenPhone }}</p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-text-field :value="formattedCpfOrCnpj" outlined hide-details :label="label" class="mb-5" disabled />
    </v-row>
    <v-row no-gutters>
      <v-text-field
        v-model="phoneNumber"
        v-mask="['(##) ####-#####', '(##) # ####-####']"
        outlined
        label="Confirme seu telefone"
        class="mb-5"
        :error-messages="phoneConfirmError"
        type="text"
        @input="$emit('remove-error')"
      />
    </v-row>
    <v-row class="mb-3" no-gutters>
      <v-btn
        width="100%"
        class="button-height"
        :color="getAssets.colors.form.buttonBackground"
        :style="{ color: getAssets.colors.form.buttonFont }"
        :loading="btnLoading"
        :disabled="phoneConfirm.length < 14"
        @click="submitPhoneNumber"
        >enviar código</v-btn
      >
    </v-row>
  </section>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'
import { formatCpfOrCnpj } from '@/helpers/cpfCnpj'
export default {
  mixins: [documentMaskMixin],
  props: {
    hiddenPhone: String,
    label: String,
    cpfCnpj: String,
    phoneConfirm: String,
    phoneConfirmError: String,
    btnLoading: Boolean
  },
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    cpfOrCnpj: {
      get() {
        return this.cpfCnpj
      },
      set(value) {
        this.$emit('set-cpf-cnpj', value)
      }
    },
    formattedCpfOrCnpj() {
      return formatCpfOrCnpj(this.cpfCnpj)
    },
    phoneNumber: {
      get() {
        return this.phoneConfirm
      },
      set(value) {
        this.$emit('set-phone-confirm', value)
      }
    }
  },
  methods: {
    submitPhoneNumber() {
      this.$emit('submit')
    }
  }
}
</script>
